import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RFQProductShow = () => {
  const location = useLocation();
  const item = location?.state?.item;
  const Navigate = useNavigate();
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (location?.state === null) {
      Navigate("/admin/dashboard");
    } else {
      setName(location?.state?.name);
      setStatus(location?.state?.status);
    }
  }, []);

  const strip = (html = "") => (html || "").replace(/<[^>]+>/g, "");

  const productImages = (() => {
    const raw = item?.product_image;
    if (!raw) return [];
    try {
      if (typeof raw === "string" && raw.trim().startsWith("[")) {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      }
      if (typeof raw === "string") return [raw];
      if (Array.isArray(raw)) return raw;
    } catch (e) {
      return typeof raw === "string" ? [raw] : [];
    }
    return [];
  })();

  const fmt = (d) =>
    d
      ? new Date(d).toLocaleString("en-GB", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
        })
      : "—";

  const Field = ({ label, value, mono }) => (
    <div>
      <div className="al-spec__lbl">{label}</div>
      <div className="al-spec__val" style={mono ? { fontFamily: "var(--font-mono)" } : undefined}>
        {value || value === 0 ? value : "—"}
      </div>
    </div>
  );

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">RFQ Product Details</h1>
          <p className="al-sub">Packaging specification submitted with this quotation request.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /></svg>
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h2 className="al-idbanner__name">{item?.title || name || "Product"}</h2>
            <span className="al-pill" style={{ background: item?.is_active ? "var(--color-success-bg)" : "var(--color-surface-2)", color: item?.is_active ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
              {item?.is_active ? "Active" : "Deactive"}
            </span>
          </div>
          <p className="al-idbanner__sub">Order Status: <strong style={{ color: "var(--color-text-primary)" }}>{item?.orderStatus || status || "—"}</strong></p>
        </div>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></svg>
          </div>
          <h3 className="al-cardhead__title">Specification</h3>
        </div>
        <div className="al-spec">
          <Field label="Product Title" value={item?.title} />
          <Field label="Material Color" value={item?.material_color} />
          <Field label="Quantity" value={item?.quantity} mono />
          <Field label="Paper GSM" value={item?.paper_gsm} mono />
          <Field label="Size" value={item?.size} mono />
          <Field label="Print Coverage" value={item?.print_coverage} />
          <Field label="Lamination" value={item?.lamination} />
          <Field label="Burst Factor" value={item?.burst_factor} mono />
          <Field label="No of Ply" value={item?.no_of_ply} mono />
          <Field label="Order Status" value={item?.orderStatus} />
          <Field label="Date & Time" value={fmt(item?.created_at)} mono />
          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Description</div>
            <div className="al-spec__val">{strip(item?.description) || "—"}</div>
          </div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Image</div>
            {productImages.length > 0 ? (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 2 }}>
                {productImages.map((img, i) => (
                  <a key={i} href={`${process.env.REACT_APP_IMAGE_URL}${img}`} target="_blank" rel="noreferrer"
                    style={{ display: "block", width: 72, height: 72, borderRadius: 11, overflow: "hidden", border: "1px solid var(--color-border)", background: "var(--color-surface-2)" }}>
                    <img src={`${process.env.REACT_APP_IMAGE_URL}${img}`} alt="Product" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </a>
                ))}
              </div>
            ) : (
              <div className="al-spec__val al-muted">No Image found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RFQProductShow;
